import Person from "./person.svg";

export default Person;
